import { TextconstantService } from 'dc-services/textconstant.service';

function processMenuMarkup(wrapper, maxScreenWidth, overviewText) {
    if (wrapper) {
        //nur bis ebene 2 im footer
        for (const liWithSubmenu of wrapper.querySelectorAll(":scope > ul > li")) {
            const subUl = liWithSubmenu.querySelector("ul");
            if (subUl) {
                const mainLink = liWithSubmenu.querySelector(":scope > a,:scope > span");
                if (mainLink) {
                    if (mainLink.tagName === 'A') {
                        if (subUl.querySelector(".all-link")) {
                            continue;
                        }

                        const allLinkLi = document.createElement("li");
                        const allLink = mainLink.cloneNode(true);
                        allLink.classList.add("all-link");
                        allLink.innerText = overviewText;

                        const icon = allLink.querySelector(".icon");
                        if (icon) {
                            icon.remove();
                        }

                        allLinkLi.appendChild(allLink);
                        subUl.insertBefore(allLinkLi, subUl.firstChild);
                    }

                    if (!mainLink.classList.contains('clickable-parent')) {
                        mainLink.addEventListener("click", function(e) {
                            if (window.innerWidth > maxScreenWidth) {
                                return;
                            }
                            if (liWithSubmenu.classList.contains("open")) {
                                liWithSubmenu.classList.remove("open");
                            } else {
                                liWithSubmenu.classList.add("open");
                            }
                            e.preventDefault();
                        });
                    }
                }
            }
        }
    }
}

function getLinkText(link) {
    const clone = link.cloneNode(true);
    clone.querySelectorAll('.navCounter').forEach(el => el.remove());
    return clone.textContent.trim();
}

function buildHybridMenu(wrapper, sourceNav, accordion = true, siblingWrapper = null, overviewText = '', backText = 'Zurück') {
    if (!wrapper || !sourceNav) return;

    wrapper.innerHTML = sourceNav.innerHTML;
    const rootUl = wrapper.querySelector(':scope > ul');
    if (!rootUl) return;

    // Slide panel container for level 3
    const slideMenu = document.createElement('div');
    slideMenu.className = 'mobileMenuDCSlides';

    const track = document.createElement('div');
    track.className = 'mobileMenuDCSlides__track';
    slideMenu.appendChild(track);

    function syncHeight() {
        const panel = track.firstElementChild;
        if (panel) slideMenu.style.height = panel.scrollHeight + 'px';
    }

    function showLevel3(level3Ul, sectionTitle, instant) {
        track.innerHTML = '';

        const panel = document.createElement('div');
        panel.className = 'mobileMenuDCSlides__panel';

        const backBtn = document.createElement('button');
        backBtn.type = 'button';
        backBtn.className = 'mobileMenuDCSlides__back';
        backBtn.innerHTML = `<i class="icon icon-arrow-left"></i><span>${backText}</span>`;
        backBtn.addEventListener('click', () => {
            wrapper.classList.remove('is-level3-view');
            if (siblingWrapper) siblingWrapper.style.display = '';
        });
        panel.appendChild(backBtn);

        const heading = document.createElement('div');
        heading.className = 'mobileMenuDCSlides__heading';
        heading.textContent = sectionTitle;
        panel.appendChild(heading);

        const ul = document.createElement('ul');
        for (const li of level3Ul.children) {
            const link = li.querySelector(':scope > a, :scope > span');
            if (!link) continue;
            const newLi = document.createElement('li');
            newLi.appendChild(link.cloneNode(true));
            ul.appendChild(newLi);
        }
        panel.appendChild(ul);
        track.appendChild(panel);

        if (instant) {
            slideMenu.style.transitionDuration = '0s';
        }

        wrapper.classList.add('is-level3-view');
        if (siblingWrapper) siblingWrapper.style.display = 'none';
        syncHeight();

        if (instant) {
            requestAnimationFrame(() => {
                slideMenu.style.transitionDuration = '';
                syncHeight();
            });
        }
    }

    // Level 1: accordion toggle + all-link (only when accordion mode)
    for (const li of rootUl.querySelectorAll(':scope > li')) {
        const subUl = li.querySelector(':scope > ul');
        const link = li.querySelector(':scope > a, :scope > span');

        if (subUl && link) {
            if (accordion) {
                // Add all-link if parent URL not already in children
                if (!subUl.querySelector('.all-link')) {
                    const childHrefs = [...subUl.querySelectorAll(':scope > li > a')].map(a => a.href);
                    if (link.href && !childHrefs.includes(link.href)) {
                        const allLi = document.createElement('li');
                        const allLink = link.cloneNode(true);
                        allLink.classList.add('all-link');
                        allLink.querySelectorAll('.icon').forEach(i => i.remove());
                        if (overviewText) {
                            allLink.textContent = overviewText;
                        }
                        allLi.appendChild(allLink);
                        subUl.insertBefore(allLi, subUl.firstChild);
                    }
                }
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    li.classList.toggle('open');
                });
            }

            // Level 2 items: link navigates + chevron trigger for level 3 slide
            for (const li2 of subUl.querySelectorAll(':scope > li')) {
                const level3Ul = li2.querySelector(':scope > ul');
                const link2 = li2.querySelector(':scope > a, :scope > span');

                if (level3Ul && link2) {
                    li2.classList.add('mobileMenuDCHasLevel3');

                    const trigger = document.createElement('button');
                    trigger.type = 'button';
                    trigger.className = 'mobileMenuDCLevel3Trigger';

                    const toggle = li2.querySelector(':scope > .navChildrenToggle');
                    if (toggle) {
                        trigger.appendChild(toggle.cloneNode(true));
                    }

                    const linkText = getLinkText(link2);
                    trigger.addEventListener('click', () => showLevel3(level3Ul, linkText, false));
                    li2.appendChild(trigger);
                }
            }
        }
    }

    // Pre-expand active path in accordion
    if (accordion) {
        for (const activeLi of wrapper.querySelectorAll('li.is-active, li.is-active-tree')) {
            let current = activeLi.parentElement;
            while (current && current !== wrapper) {
                if (current.tagName === 'LI') {
                    current.classList.add('open');
                }
                current = current.parentElement;
            }
        }
    }

    wrapper.appendChild(slideMenu);

    // Pre-show slide for the deepest active item that has children
    // In accordion mode: look for active level 2 items with level 3 children
    // In non-accordion mode: look for active level 1 items with children
    let activeWithChildren = null;

    if (accordion) {
        for (const li of rootUl.querySelectorAll(':scope > li > ul > li')) {
            if ((li.classList.contains('is-active-tree') || li.classList.contains('is-active')) && li.querySelector(':scope > ul')) {
                activeWithChildren = li;
                break;
            }
        }
    } else {
        for (const li of rootUl.querySelectorAll(':scope > li')) {
            if ((li.classList.contains('is-active-tree') || li.classList.contains('is-active')) && li.querySelector(':scope > ul')) {
                activeWithChildren = li;
                break;
            }
        }
    }

    if (activeWithChildren) {
        const childUl = activeWithChildren.querySelector(':scope > ul');
        const link = activeWithChildren.querySelector(':scope > a, :scope > span');
        if (childUl && link) {
            showLevel3(childUl, getLinkText(link), true);
        }
    }
}

export async function initMobileMenu() {
    const [overviewText, backText] = await Promise.all([
        TextconstantService.getTextConstant('overview').then(t => t || 'Übersicht'),
        TextconstantService.getTextConstant('back').then(t => t || 'Zurück'),
    ]);

    const mobileMenu = document.getElementById('mobileMenu');
    const mainNav = document.querySelector(".footerDCMainNavigation");
    const specialNav = document.querySelector(".footerDCSpecialNavigation");

    if (mobileMenu) {
        const mainWrapper = mobileMenu.querySelector(".js-loadMenuFromFooter");
        const specialWrapper = mobileMenu.querySelector(".js-loadSpecialMenuFromFooter");
        const mq = window.matchMedia("(max-width: 767px)");

        function applyMenu() {
            if (mq.matches) {
                if (mainWrapper && mainNav) {
                    buildHybridMenu(mainWrapper, mainNav.cloneNode(true), true, specialWrapper, overviewText, backText);
                }
                if (specialWrapper && specialNav) {
                    buildHybridMenu(specialWrapper, specialNav.cloneNode(true), false, mainWrapper, overviewText, backText);
                }
            } else {
                if (mainWrapper && mainNav) mainWrapper.innerHTML = mainNav.innerHTML;
                if (specialWrapper && specialNav) specialWrapper.innerHTML = specialNav.innerHTML;
            }
        }

        applyMenu();
        mq.addEventListener("change", applyMenu);
    }

    if (mainNav) processMenuMarkup(mainNav, 767, overviewText);
}